import type React from "react";

import { SectionType } from "@/api/interfaces/pageLayout";
import { AlertBlock } from "@/base/blocks/AlertBlock";
import BenefitsBlock from "@/base/blocks/BenefitsBlock/BenefitsBlock";
import { renderCmsBlocks } from "@/base/blocks/blockRegistry";
import ApolloClubCard from "@/base/blocks/ClaimYourClubCard";
import IntroductionBlocks from "@/base/blocks/IntroductionBlocks";
import LocationsBlock from "@/base/blocks/LocationsBlock";
import PerkBlock from "@/base/blocks/PerkBlock";
import SignInBlock from "@/base/blocks/SignInBlock";
import { CmsBlock, CmsBlocks } from "@/base/components/Global";
import { CmsPage } from "@/base/components/Global/cmsPage";
import { fetchPublicHomePage } from "@/store/cms";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

const publicRegistry = {
  [SectionType.LOCATION]: LocationsBlock,
  [SectionType.BENEFITS_DETAILS]: IntroductionBlocks,
  [SectionType.BENEFITS]: BenefitsBlock,
  [SectionType.GIFT_CARDS]: PerkBlock,
  [SectionType.CLUB_CARD]: ApolloClubCard,
  [SectionType.ALERT]: AlertBlock,
};

const PublicHomePage: React.FC = () => {
  const publicHomePage = useAppSelector((state) => state.cms.publicHomePage);
  const dispatch = useAppDispatch();

  return (
    <CmsPage
      name="PublicHomePage"
      pageStateMachine={publicHomePage}
      fetchPage={() => dispatch(fetchPublicHomePage())}
    >
      {({ page }) => (
        <CmsBlocks>
          <CmsBlock addBreak isSmall>
            <SignInBlock />
          </CmsBlock>
          {renderCmsBlocks(page.components, publicRegistry)}
        </CmsBlocks>
      )}
    </CmsPage>
  );
};

export default PublicHomePage;
